<!--
 * @Author: Lemon C
 * @Date: 2024-11-11 09:39:57
 * @LastEditTime: 2024-12-23 11:56:43
-->

<template>
    <div class="sup-bady">
        <BannerComp class="banner-box"></BannerComp>
        <FunctionModuleComp class="function-module-box" :function_list="function_list"></FunctionModuleComp>
        <ToolModuleComp class="tool-module-box"></ToolModuleComp>
        <PrivatServiceModuleComp class="privat-service-module-box"></PrivatServiceModuleComp>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue';
import BannerComp from '@/components/Product/BannerComp.vue';
import FunctionModuleComp from '@/components/Product/FunctionModuleComp.vue';
import ToolModuleComp from '@/components/Product/ToolModuleComp.vue';
import PrivatServiceModuleComp from '@/components/Product/PrivatServiceModuleComp.vue';
import { getEngineFunctionList } from '@/service/interface';

const { proxy } = getCurrentInstance();

const function_list = ref([]); //功能列表

onMounted(() => {
    service_engine_fun_list();
});

// MARK Service 获取功能介绍列表
const service_engine_fun_list = () => {
    proxy.$showLoading();
    getEngineFunctionList().then((res) => {
        proxy.$hideLoading();
        if (res.isSuccess) {
            function_list.value = res.data;
        }
    });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 100px;

    .banner-box {
        width: 100%;
        height: 500px;
    }

    .function-module-box {
        margin-top: 74px;
        width: 100%;
    }

    .tool-module-box {
        width: 100%;
        margin-top: 80px;
        box-sizing: border-box;
    }

    .privat-service-module-box {
        flex-direction: unset;
        margin-top: 90px;
        width: 100%;
        box-sizing: border-box;
    }
}
</style>
